import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { VerificationCount, VerificationCountByMonth } from './types'
import { $params } from '../../../../features/router'

export const verificationCountMounted = createEvent()

export const getVerificationCount = fx<void, VerificationCount>({
  method: 'GET',
  url: '/verification/count',
})

export const getVerificationCountByMonth = fx<void, VerificationCountByMonth[]>({
  method: 'GET',
  url: '/verification/count-by-month',
})

export const $verificationCount = restore<VerificationCount>(
  getVerificationCount.doneData.map((doneData) => doneData.body),
  { count: 0 },
)

export const $verificationCountByMonth = restore<VerificationCountByMonth[]>(
  getVerificationCountByMonth.doneData.map((doneData) => doneData.body),
  [],
)

sample({
  clock: [verificationCountMounted],
  source: $params,
  fn: () => ({}),
  target: [getVerificationCount],
})

sample({
  clock: [verificationCountMounted],
  source: $params,
  fn: () => ({}),
  target: [getVerificationCountByMonth],
})
